export const ClientSeasonDependencyTypes = {
  ClientSeasonApiService: Symbol.for('ClientSeasonApiService'),
  ClientSeasonApiDataTransformer: Symbol.for('ClientSeasonApiDataTransformer'),
  ClientSeasonRepository: Symbol.for('ClientSeasonRepository'),
  ClientSeasonService: Symbol.for('ClientSeasonService'),
};
